import React, { useContext, useEffect, useState } from 'react'
import Breadcrumb from '../Component/BradeCrum'
import Product from '../Component/Product'
import HeaderMobile from '../Component/MobileHader'
import { Hourglass } from "react-loader-spinner";

import axios from 'axios'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import no_img from "../assets/Img/no-image.jpg";
import { BCNContext } from '../Context/BreadcrumName'

const ImageWithFallback = ({ src }) => {
    const [imgSrc, setImgSrc] = useState(src);
  
    useEffect(()=>{
      // console.log("okokokokokokokoko",imgSrc)
    },[])
  
    const handleError = () => {
      setImgSrc(no_img);
    };
  
    return (
      <img 
        src={imgSrc} 
        alt='img' 
        onError={handleError}
      />
    );
  };

const AllProducts = () => {
  const {setBcnHeader} = useContext(BCNContext);
  const [heading, setHeading] = useState("Product Categories")
  const [bcheading, setBcheading] = useState("Product Categories")
const [productData, setProductData] = useState([])
 const [loading, setLoading] = useState(true);
  useEffect(()=>{
    try {
     
        axios.get(`${process.env.REACT_APP_GRIPHOLD_API_URL}/api/auth/getallcategory`).then((res)=>{

            setProductData(res.data)
          
        });
     
    }
    catch(error){
        console.log(error)
    }
  },[])
    useEffect(() => {
      const handleLoading = async () => {
        setLoading(true); // Start loading
        window.scrollTo(0, 0);
  
        // Simulate loading for demonstration purposes
        await new Promise((resolve) => setTimeout(resolve, 2000));
  
        setLoading(false); // Stop loading
      };
  
      handleLoading();
    }, []);
  return (
    <React.Fragment>
         {loading ? (
      
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                }}
              >
                <Hourglass
                  height={80}
                  width={80}
                  color="#01458e"
                  ariaLabel="loading-content"
                />
              </div>
            ) : (
      <div>
      <HeaderMobile/>
     <Breadcrumb heading={heading}  bTitle={bcheading}/>
     <div className="container-fluid">
  <Row className=" g-xl-4 gy-5">
    <Col xxl={12} className=" order-xl-2 order-1">
      <Row className=" gy-5 mb-70 product-page">
        {productData && productData.filter((item)=>item.IsActive===true).map((data)=>
        <Col lg={3} sm={6} className="col-sm-6" key={data._id}>
          <div className="product-card">
            <div className="product-card-img">
              <Link  to={`/productlist/${data._id}`} onClick={()=>setBcnHeader({name : data.categoryName, url : `/productList/${data._id}`})}>

                <ImageWithFallback 
          src={data.categoryImage? `${process.env.REACT_APP_GRIPHOLD_API_URL}/${data.categoryImage}` : no_img} 
        />
              </Link>
            </div>
            <div className="product-card-content">
              <h6 className="mb-0"><Link  to={`/productlist/${data._id}`} onClick={()=>setBcnHeader({name : data.categoryName, url : `/productList/${data._id}`})}>{data.categoryName}</Link></h6>
            </div>
          </div>
        </Col>
    )}
      </Row>
    </Col>
  </Row>
</div>
</div>
  )}
    </React.Fragment>
  )
}

export default AllProducts